define("SageDotCom/Components/CustomerSuccess/CustomerSuccessRelated", [
    "jquery",
    "text!SageDotCom/Components/Templates/SpotlightCard.html",
    "SageDotCom/Utility/sageMatchHeight"
], function ($, _cardTemplate, SageMatchHeight, mh, eventManager, slick) {

    function CustomerStoryCollection(scope, storyData, desktopMinimum, desktopMaximum, mobileMaximum) {
        Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
        Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });

        var relatedDiv = this.$scope.find(".related-customer-story-listing");
        var storyContainer = relatedDiv.find(".customer-success-stories");
        var isMobile = storyContainer.hasClass("is-mobile");
        var shouldShow = isMobile ? storyData.length > 0 : storyData.length >= desktopMinimum;

        if (!shouldShow) {
            relatedDiv.remove();
        } else {
            var numberToShow = isMobile ? mobileMaximum : desktopMaximum;

            var relatedTemplate = _.template(_cardTemplate);
            var html = "";
            for (var i = 0; i < numberToShow && i < storyData.length; i++) {
                html += relatedTemplate(storyData[i]);
            }
            storyContainer.html(html);

            var getLineHeight = function(element) {
                var lineHeight = window.getComputedStyle(element)["line-height"];
                return lineHeight === "normal"
                    ? 1.12 * parseFloat(window.getComputedStyle(element)["font-size"])
                    : parseFloat(lineHeight);
            };

            this.$scope.find("h4.story-headline").each(function(i, item) {
                var $item = $(item);
                $item.attr("data-text-content", item.textContent);
                $item.attr("data-line-height", getLineHeight(item));
                $item.attr("lang", document.documentElement.lang);
            });

            this._updateItems();

            scope.addEventListener('lazy-load-evt', this._setSlider());
        }
    }

    CustomerStoryCollection.prototype._updateItems = function () {
        var self = this;
        var stories = this.$scope.find(".customer-success-story");
        SageMatchHeight.prototype.applyBinding(stories, true, { byRow: false });
        this.$scope.find("h4.story-headline").each(function (i, item) {
            self._doEllipsis(3, item);
        });

        this._cropstoryImages();
    };

    CustomerStoryCollection.prototype._doEllipsis = function (lines, element) {
        var $element = $(element),
            inner = document.createElement("SPAN"),
            text = $element.attr("data-text-content"),
            lineHeight = $element.attr("data-line-height"),
            paddingTop = $element.css("padding-top"),
            maxHeight = lines * lineHeight + paddingTop,
            textParts = text.split(" ");

        if (!text) return;

        element.innerHTML = "";
        element.style.height = "auto";
        element.style.maxHeight = maxHeight + "px";
        element.appendChild(inner);
        inner.innerHTML = text;
        inner.style.display = "block";

        if (inner.clientHeight < maxHeight) return;

        while (inner.clientHeight > maxHeight) {
            textParts.pop();
            inner.innerHTML = textParts.join(" ") + "...";
        }
    };

    CustomerStoryCollection.prototype._cropstoryImages = function () {
        var $images = this.$scope.find("div.story-thumbnail", "img.customer-logo", "img.product-logo"),
            imageHeights = [];

        $images.each(function (i, item) {
            imageHeights.push(item.height);
        });

        var minHeight = Math.min.apply(Math, imageHeights);

        $images.parent().height(minHeight);
    };

    CustomerStoryCollection.prototype._setSlider = function () {
        var self = this;

        new Promise(function(resolve, reject) {
            var settings = {
                draggable: true,
                dots: true,
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                centerMode: false,
                touchThreshold: 10,
                mobileFirst: false,
                responsive: [
                    {
                        breakpoint: 1440,
                        settings: {
                            slidesToShow: 2.75,
                            slidesToScroll: 2,
                            centerMode: false,
                        }
                    },
                    {
                        breakpoint: 1080,
                        settings: {
                            slidesToShow: 1.6,
                            slidesToScroll: 2,
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.138,
                            slidesToScroll: 1,
                            centerMode: false
                        }
                    }
                ]
            };

            var $slick = $(".customer-success-stories", self.$scope);
            
            // fix stripe
            $('.customer-success-stories').closest('.score-stripe').addClass('overflow-hidden position-relative');

            $slick.slick(settings);

            self.$scope.on("init setPosition",
                function() {
                    self._updateItems();
                });
            resolve();
        });
    };

    CustomerStoryCollection.init = function (args) {
        return new CustomerStoryCollection(args.scope, args.data, args.desktopMinimum, args.desktopMaximum, args.mobileMaximum);
    };

    return CustomerStoryCollection;

});
define("SageDotCom/Components/Content/CustomerSuccess/CustomerSuccessRelated", function(){});

